import { AuthResponse, MccsRoles } from '@/@types/generated'
import { hasRole } from '@/components/Atoms/Permissions'
import { AutonomousVehiclesFeature } from './autonomous-vehicles'
import { CertificatesFeature } from './certificates'
import { Feature } from './feature'
import { InternalRoles } from '../utils'

export const LicensingAgentsFeature = {
  // Roles that are eligible for the Licensing Agents feature
  Roles: [MccsRoles.LICENSING_AGENCY_OWNER, MccsRoles.LICENSING_AGENCY_USER],

  // Determine if the feature is enabled for the given user
  // - Credentialing users
  // - Licensing Agency owners/users
  isEnabled: (user: AuthResponse | null): boolean =>
    hasRole(
      [
        MccsRoles.CREDENTIALING_ADMIN,
        MccsRoles.CREDENTIALING,
        ...LicensingAgentsFeature.Roles,
      ],
      user
    ),

  // Sub-features

  // Application for Licensing Agency
  Application: {
    // Anyone can apply for a licensing agency, UNLESS:
    // - They are already an AV operator
    // - They are already a motor carrier
    // - They are an internal user
    // - They are already a broker
    isEnabled: (user: AuthResponse | null): boolean =>
      !hasRole(
        [
          ...AutonomousVehiclesFeature.Roles,
          ...CertificatesFeature.Roles,
          ...InternalRoles,
          MccsRoles.BROKER,
        ],
        user
      ) ||
      // ...OR is a licensing agency user (can apply for another agency)
      hasRole(LicensingAgentsFeature.Roles, user),
  } satisfies Feature,

  // Licensing Agency Details can be updated
  Details: {
    isEnabled: (user: AuthResponse | null): boolean =>
      // Credential admins
      // ...or owner
      hasRole(
        [MccsRoles.CREDENTIALING_ADMIN, MccsRoles.LICENSING_AGENCY_OWNER],
        user
      ),
  } satisfies Feature,

  // Licensing Agency Users can be added/removed
  Users: {
    isEnabled: (user: AuthResponse | null): boolean =>
      // Credential admins
      // ...or owner
      hasRole(
        [MccsRoles.CREDENTIALING_ADMIN, MccsRoles.LICENSING_AGENCY_OWNER],
        user
      ),
  } satisfies Feature,

  // Licensing Agency history can be viewed
  History: {
    // Same as users
    isEnabled: (user: AuthResponse | null): boolean =>
      LicensingAgentsFeature.Users.isEnabled(user),
  } satisfies Feature,
} satisfies Feature
